package org.vreo.devicehub.features.core.domain.device.message

import kotlinx.serialization.Serializable

/**
 * Anpr device message image request dto
 *
 * @property path path to image
 */
@Serializable
data class AnprMessageImageRequestDto(
    val path: String
)